import axios from 'axios'
import qs from 'qs'
import store from '@/vuex'
import router from '@/router'
import {Toast} from 'vant'

function checkPermission(data){
    if(data.result.success==444){
       Toast(data.result.info)
       store.commit("HIDE_LOADING")
       router.push("/login")
       return false;
    }
}

const config={
    baseURL: process.env.VUE_APP_API,
    timeout: 60000
  }

async function get(url,data){
    config['url']=url
    config['headers']={'bbshoptoken':store.state.user.token,'Content-Type':'application/x-www-form-urlencoded'}
    config['method']='get'

    store.commit("SHOW_LOADING")
    const result=await axios.post(url,qs.stringify(data),config)
    store.commit("HIDE_LOADING")

    checkPermission(result.data)
    return result.data
}

async function post(url,data){
    config['url']=url
    config['headers']={'bbshoptoken':store.state.user.token,'Content-Type':'application/x-www-form-urlencoded'}
    config['method']='post'

    store.commit("SHOW_LOADING")
    const result=await axios.post(url,qs.stringify(data),config)
    store.commit("HIDE_LOADING")

    checkPermission(result.data)
    return result.data
}

async function put(url,fileData){
    config['url']=url
    config['headers']={'bbshoptoken':store.state.user.token,'Content-Type':'multipart/form-data'}
    config['method']='post'

    let formData = new FormData() 
    formData.set('type',fileData.type)
    formData.set('image', fileData.file)
    
    store.commit("SHOW_LOADING")
    const result=await axios.post(url,formData,config)
    store.commit("HIDE_LOADING")

    checkPermission(result.data)
    return result.data
}
export {get,post,put} 